import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { parse } from 'query-string';
import { LocalStorage } from '../../../../utils/utils';
import { iFMessage } from '../../../../hoc/IntlComponents';
import { array, object, func } from 'prop-types';
import {
  startSetEditProfile,
  startSetProfile,
  startConfirmPhone,
  startRemoveSocialAccount,
  startSetSocialAccount,
} from '../../../../actions/webmaster';
import { startSetAppSettings, startSetSocials } from '../../../../actions/app';
import Card from '../../../../components/Card/Card';
import ProfileEditForm from '../../components/ProfileEditForm/ProfileEditForm';
import AlertModal from '../../../../modals/AlertModal/AlertModal';
import ConfirmSMSModal from '../../../../modals/ConfirmSMSModal/ConfirmSMSModal';
import WithAlert from '../../../../hoc/WithAlert';
import WithProfileNav from '../../hoc/withProfileNav';

class ProfilePage extends Component {
  static propTypes = {
    profile: object.isRequired,
    timezones: array.isRequired,
    startSetEditProfile: func,
    startSetProfile: func,
    startConfirmPhone: func,
  };

  static defaultProps = {
    profile: {},
    timezones: [],
  };

  state = {
    error: false,
    smsModal: false,
    loading: false,
    errors: {},
    phone: '',
    modalType: 'call',
  };

  componentDidMount() {
    const {
      profile: { email },
      intl,
    } = this.props;
    if (!email.trim().length) {
      this.props.showAlert({
        alertType: 'danger',
        dismissable: false,
        message: iFMessage({ intl, id: 'profile.alert.no-email' }),
      });
    }

    this.setState({ loading: true });

    this.props
      .startSetSocials()
      .then(() => this.getAccessData())
      .then(data => this.addSocialAccount(data))
      .then(() => this.setState({ loading: false }));

    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.profile.email.trim().length) {
      if (
        nextProps.profile &&
        nextProps.profile.email &&
        nextProps.profile.email !== this.props.profile.email
      ) {
        this.props.closeAlert();
      }
    }
  }

  handleSavePhone = phone => {
    this.sendSMS({ phone });
  };

  toggleSmsModal = () => {
    this.setState(prevState => ({
      smsModal: !prevState.smsModal,
      errors: { ...prevState.errors, phone_confirmation: '' },
    }));
  };

  toggleErrorModal = () => {
    this.setState(prevState => ({ error: !prevState.error }));
  };

  sendSMS = data => {
    this.setState({ loading: true });
    this.props
      .startConfirmPhone(data)
      .then(response => {
        if (data.code) {
          this.props.startSetProfile().then(() => {
            if (this._isMounted) {
              return this.setState(() => ({
                loading: false,
                smsModal: false,
                phone: '',
              }));
            }
          });
        } else {
          const modalType = response?.items[0]?.transport;
          this.setState(() => ({
            smsModal: true,
            phone,
            modalType,
            loading: false,
          }));
        }
      })
      .catch(({ response = {} }) => {
        if (response.data && response.data.error) {
          const { message } = response.data.error;
          if (this._isMounted) {
            if (data.code) {
              this.setState(prevState => ({
                error: true,
                errors: {
                  ...prevState,
                  phone_confirmation: message.message,
                },
                phone: '',
                loading: false,
              }));
            } else {
              this.handleError(message.message);
              this.setState({
                loading: false,
              });
            }
          }
        }
      });
  };

  submit = data => {
    const { timezone, theme } = this.props.profile;

    this.setState(() => ({ loading: true }));

    this.props
      .startSetEditProfile(data)
      .then(() => {
        if ((data.timezone && data.timezone !== timezone) || (data.theme && data.theme !== theme)) {
          window.location.reload();
        }
        return this.props.startSetProfile();
      })
      .then(() => this.props.startSetAppSettings())
      .then(() => this.setState(() => ({ loading: false })));
  };

  getAccessData = () => {
    const { hash, search } = this.props.history.location;

    let params = parse(search);

    if (!params.code && !params.error && hash !== '#_=_') {
      params = parse(hash);
    }

    if ((params.access_token || params.code) && params.state) {
      try {
        const { security_hash, provider } = JSON.parse(params.state);
        const { expires_in, user_id } = params;
        const token = params.access_token || params.code;
        const { origin, pathname } = window.location;
        const redirect_uri = `${origin}${pathname}`;

        // сверяется случайное число, генерируемое при подключении, смотреть OFFERRUM-1129
        if (security_hash && security_hash === LocalStorage.get('security_hash')) {
          LocalStorage.remove('security_hash');
          return {
            token,
            expires_in,
            user_id,
            redirect_uri,
            provider,
          };
        } else {
          throw new Error('Security hash is invalid. Probably someone tries to hack you');
        }
      } catch (error) {
        this.handleError('There was an error when receiving an access key.');
        return null;
      }
    } else if (params.error && params.error_description) {
      this.handleError(decodeURIComponent(params.error_description));
    }

    return null;
  };

  removeParams = () => {
    this.props.history.replace(window.location.pathname);
  };

  addSocialAccount = data => {
    if (data !== null) {
      return this.props
        .startSetSocialAccount(data)
        .then(() => {
          const { intl, showAlert } = this.props;
          this.removeParams();
          showAlert({
            alertType: 'success',
            message: iFMessage({ intl, id: 'socials.account.connected' }),
            closeInSeconds: 5,
            dismissable: false,
          });
        })
        .catch(({ response = {} }) => {
          if (response.data && response.data.error) {
            const { message: error } = response.data.error;
            this.handleError(error.message);
          }

          setTimeout(() => {
            this.removeParams();
          }, 3000);
        });
    }
  };

  handleError = message => {
    this.props.showAlert({
      alertType: 'danger',
      dismissable: false,
      closeInSeconds: 3,
      message,
    });
  };

  getAccounts = () =>
    this.props.accounts.reduce((accounts, acc) => ({ ...accounts, [acc.provider]: acc }), {});

  getSocials = () => Object.values(this.props.socials).map(social => social);

  handleUnsubscribe = accountId => {
    this.setState({ loading: true });
    const { startRemoveSocialAccount, intl } = this.props;

    startRemoveSocialAccount(accountId)
      .then(() => {
        this.props.showAlert({
          alertType: 'success',
          dismissable: false,
          closeInSeconds: 3,
          message: iFMessage({ intl, id: 'socials.account.disconnected' }),
        });

        this.setState({ loading: false });
      })
      .catch(({ response = {} }) => {
        if (response.data && response.data.error) {
          const { message: error } = response.data.error;
          this.handleError(error.message);
          this.setState({ loading: false });
        }
      });
  };

  render() {
    const { loading, error, smsModal, errors, phone, modalType } = this.state;
    const { profile, timezones } = this.props;

    return (
      <>
        <Card loading={loading}>
          <Card.Body>
            <ProfileEditForm
              handleUnsubscribe={this.handleUnsubscribe}
              accounts={this.getAccounts()}
              socials={this.getSocials()}
              submit={this.submit}
              profile={profile}
              timezones={timezones}
              onSavingPhone={this.handleSavePhone}
              updateProfile={this.props.startSetProfile}
            />
          </Card.Body>
        </Card>
        {/* {errors.phone_confirmation && (
          <AlertModal
            className="sms-errors-modal"
            open={error}
            title={<FormattedMessage id="main.error" defaultMessage="Error" />}
            message={errors.phone_confirmation}
            onClose={this.toggleErrorModal}
          />
        )} */}

        <ConfirmSMSModal
          error={errors.phone_confirmation}
          isPhoneCall={modalType === 'call'}
          isOpen={smsModal}
          phone={phone}
          sendSms={this.sendSMS}
          onCancel={this.toggleSmsModal}
          toggleModal={this.toggleSmsModal}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.webmaster.profile,
  timezones: state.app.globalSettings.timezones,
  socials: state.app.socials,
  accounts: state.webmaster.profile.socials,
});

const mapDispatchToProps = dispatch => ({
  startSetEditProfile: data => dispatch(startSetEditProfile(data)),
  startSetProfile: params => dispatch(startSetProfile(params)),
  startConfirmPhone: data => dispatch(startConfirmPhone(data)),
  startSetAppSettings: () => dispatch(startSetAppSettings()),
  startRemoveSocialAccount: accountId => dispatch(startRemoveSocialAccount(accountId)),
  startSetSocials: () => dispatch(startSetSocials()),
  startSetSocialAccount: data => dispatch(startSetSocialAccount(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(WithAlert(WithProfileNav(ProfilePage))));
